_ = require 'underscore'
$ = require 'jquery'
Auth = require 'db/auth'
BaseDirectoryView = require './base-directory-view'
BoardAddToTeam = require 'views/board-menu/board-add-to-team-view'
defaultPowerUpIcon = require 'images/directory/icons/customIcon.png'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
Format = require 'lib/markdown/format'
l = require 'lib/localize'
ModelLoader = require 'db/model-loader'
PluginIO = require 'views/internal/plugins/plugin-io'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
t = require('views/internal/recup-with-helpers')('directory_power_up_item')
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
View = require 'view'
xtend = require 'xtend'
{ BasicAtom, DescriptionAtom, FeaturedAtom } = require '@trello/directory-components'

class PowerUpSettings extends React.Component
  displayName: 'PowerUpSettings'

  render: t.renderable ->
    { authorize, disable, supportsSettings, showSettings, supportsAuth, hasPersonalSettings, removeData, authStatus } = @props
    t.ul '.pop-over-list', ->
      if supportsAuth && !(authStatus && authStatus.authorized)
        t.li onClick: authorize, ->
          t.a ->
            t.format 'authorize-account'
      else
        if supportsSettings
          t.li onClick: showSettings, ->
            t.a ->
              t.format 'edit-power-up-settings'
        if hasPersonalSettings
          t.li onClick: removeData, ->
            t.a ->
              t.format 'remove-personal-settings'
      t.li onClick: disable, ->
        t.a ->
          t.format 'disable'

class BusinessClassAd extends React.Component
  displayName: 'BusinessClassUpsell'

  render: t.renderable ->
    { upgradeUrl, createTeam, onUpgradeClick, onCloseClick } = @props
    t.div '.content', ->
      t.a '.icon-close.icon-lg', { href: '#', onClick: onCloseClick }
      t.h2 ->
        t.format 'this-board-has-reached-its-power-up-limit'
      t.p ->
        t.format 'teams-get-one-free-power-up-per-board-upgrade-to-business-class-for-additional-power-ups'
      t.p '.small', ->
        t.format 'additional-fees-may-be-required-for-paid-power-ups'
      t.a '.button-link.mod-full', { href: '#', onClick: onUpgradeClick }, ->
        t.format 'upgrade'

module.exports = class DirectoryPluginItemView extends BaseDirectoryView
  className: 'directory-listing-powerup'

  initialize: ({ @plugin, @currentPage, @directoryView }) ->
    super
    @canEnable = @model.editable()

    @initialData =
      canEnable: @model.editable()
      isLegacy: @plugin.id in _.pluck(directoryLegacyPowerUps, 'id')

    @io = PluginIOCache.get(@plugin)

    if @initialData.isLegacy
      legacyPlugin = _.findWhere directoryLegacyPowerUps, { id: @plugin.id }
      name = legacyPlugin.name
      @pluginDetails = xtend legacyPlugin,
        displayName: l(['power ups', name, 'name'])
        description: l(['power ups', name, 'description'])
    else
      @pluginDetails =
        displayName: @io.getName()
        description: @io.getDescription()
        iconUrl: @io.getIconUrl()
        overview: @io.getOverview()
        author: @plugin.get('author')

    @listenTo @model, 'change:idOrganization change:powerUps', @frameDebounce @render
    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @render
    @listenTo @model, 'cancel-add-to-team', -> PopOver.hide()
    @subscribe @model.boardPluginList.snoop(), @frameDebounce @render
    @subscribe pluginsChangedSignal(@model), @frameDebounce @render

  events:
    'click': 'navigateToListing'

  navigateToListing: (e) ->
    if !@$(e.target).is('a')
      @directoryView?.navigate(null, null, @plugin.id)

  enable: (e) ->
    Util.stop(e)

    # Hide the popover if open.
    if PopOver.isVisible
      PopOver.hide()

    # Enable the Power-Up for the board.
    if @model.canEnableAdditionalPowerUps()
      @model.enablePlugin(@plugin.id)
      trackUe(@currentPage, 'enables', 'Power-Up', '', '', 'enable button', @plugin.id)
    else
      elem = e.target

      if @model.hasOrganization()
        upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)

      # Redirect to the Business Class page if the user doesn't own the board.
      if !@model.owned()
        upgradeUrl = '/business-class'

      # Show business class ad.
      PopOver.toggle
        autoPosition: true
        hideHeader: true
        elem: elem
        reactElement: React.createElement BusinessClassAd,
          onUpgradeClick: (e) => @onUpgradeClick(e)
          onCloseClick: (e) => @onUpgradeAdCloseClick(e)
        displayType: 'directory-business-class-popover'
    return

  onUpgradeClick: (e) ->
    Util.stop(e)
    trackUe('Power-Up BC upgrade popover ad', 'clicks', 'upgrade button')

    if !@model.owned()
      window.location = '/business-class'
      return
    else if @model.hasOrganization()
      window.location = Controller.getBoardPowerUpsUpgradeUrl(@model)
      return

    ModelLoader.loadMyOrganizations()
    PopOver.toggle
      autoPosition: true
      elem: e.target
      getViewTitle: => 'Upgrade to Business Class'
      view: new BoardAddToTeam({ @model })

  onUpgradeAdCloseClick: (e) ->
    Util.stop(e)
    trackUe('Power-Up BC upgrade popover ad', 'close', 'Power-Up BC upgrade popover ad')
    PopOver.hide()

  isGrandfathered: ->
    @initialData.isLegacy && @pluginDetails.name in @model.get('powerUps')

  disable: (elem) ->
    if @isGrandfathered()
      removePowerUp = =>
        @model.pull('powerUps', @pluginDetails.name)

      if @model.getOrganization()?.isFeatureEnabled('plugins')
        removePowerUp()
      else
        Confirm.pushView 'disable power up',
          elem: elem
          model: @model
          confirmBtnClass: 'negate'
          fxConfirm: removePowerUp
    else
      @model.disablePlugin(@plugin.id)

    trackUe(@currentPage, 'disables', 'Power-Up', '', '', 'disable button', @plugin.id)

  getEnabledState: ->
    if @initialData.isLegacy
      @model.isPowerUpEnabled(@pluginDetails.name)
    else
      @model.isPluginEnabled(@plugin.id)

  hasPersonalSettings: ->
    pluginData = _.extend Auth.me().getPluginData(@plugin.id), @model.getPluginData(@plugin.id)
    _.any pluginData, ({ private: privateData }) -> privateData?

  showPowerUpSettings: (elem) ->
    trackUe(@currentPage, 'opens', 'Power-Up', '', '', 'edit-settings', @plugin.id)
    if (@initialData.isLegacy)
      PopOver.pushView
        elem: elem
        view: @pluginDetails.settingsView(@model)
        autoPosition: true
    else
      PluginRunner.one
        plugin: @plugin
        command: 'show-settings'
        board: @model
        el: elem
      .done()

    return

  showAuthorization: (elem) ->
    trackUe(@currentPage, 'opens', 'Power-Up', '', '', 'show-authorization', @plugin.id)
    PluginRunner.one
      plugin: @plugin
      command: 'show-authorization'
      board: @model
      el: elem
    .done()
    return

  clearData: (elem) ->
    Confirm.pushView 'clear plugin data',
      elem: elem
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.clearPluginData(@plugin.id)
        Auth.me().clearPluginData(@plugin.id)
        trackUe(@currentPage, 'clicks', 'Power-Up', '', '', 'remove-data', @plugin.id)
        if @io.supports('remove-data')
          return PluginRunner.one
            plugin: @plugin
            command: 'remove-data'
        else
          return
    return

  toggleOptions: (e) ->
    Util.stop(e)
    elem = e.target

    bindElemAction = (action) => _.bind(action, @, elem)

    trackUe(@currentPage, 'opens', 'Power-Up', '', '', 'show-settings', @plugin.id)

    Promise.props
      supportsAuth: @io.supports('show-authorization')
      supportsSettings: @pluginDetails.settingsView || @io.supports('show-settings')
      hasPersonalSettings: @hasPersonalSettings()
    .then (data) =>
      if data.supportsAuth
        return PluginRunner.one
          timeout: 1000
          plugin: @plugin
          command: 'authorization-status'
          board: @model
        .then (authStatus) ->
          xtend data, { authStatus: authStatus }
      return data
    .then (data) =>
      PopOver.toggle
        autoPosition: true
        getViewTitle: => @io.getName()
        elem: elem
        reactElement: React.createElement PowerUpSettings, {
          key: @plugin.id
          disable: (e) =>
            PopOver.hide()
            @disable(e)
          authorize: bindElemAction @showAuthorization
          showSettings: bindElemAction @showPowerUpSettings
          removeData: bindElemAction(@clearData)
          supportsSettings: data.supportsSettings
          supportsAuth: data.supportsAuth
          hasPersonalSettings: data.hasPersonalSettings
          authStatus: data.authStatus
        }

  getTagline: ->
    powerUpDetailsRawText = $(Format.markdownAsHtml(@pluginDetails.description)).text()

    if powerUpDetailsRawText.length > 130
      return "#{ powerUpDetailsRawText.substring(0, 130).trim() }…"

    return powerUpDetailsRawText

  renderContent: ->
    { author, iconUrl, description, displayName, overview } = @pluginDetails

    Atom = BasicAtom
    atomType = @options.atomType
    if atomType == 'featured'
      Atom = FeaturedAtom
    else if atomType == 'description'
      Atom = DescriptionAtom

    React.createElement Atom, {
      id: @plugin.id
      author: author
      shortDescription: overview || @getTagline()
      logoUrl: iconUrl || defaultPowerUpIcon
      heroUrl: @plugin.heroImage
      name: displayName
      isActive: @getEnabledState({ id: @plugin.id })
      onEnable: @enable.bind(@)
      onSettings: @toggleOptions.bind(@)
    }

  render: ->
    super
    @$el.data('idPlugin', @plugin.id)
    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-plugin-item-view.coffee